var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { autocomplete: "off" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
        },
      },
    },
    _vm._l(_vm.customFields, function (field, index) {
      return _c("div", { key: field.id, staticClass: "row no-gutters" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            index === _vm.firstOrphanIndex
              ? [
                  _c("hr"),
                  _vm._v(" "),
                  _c("p", { staticClass: "bold mb-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("global.doorr.deletedFields")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "small mb-0" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "custom-fields.messages.deletedFields.previouslyCreatedFields",
                            { element: _vm.getElementName() }
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "small" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "custom-fields.messages.deletedFields.permanentlyRemoved",
                            {
                              element: _vm.getElementName(),
                            }
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "custom-data-field",
              _vm._b(
                {
                  ref: "customDataFieldElement",
                  refInFor: true,
                  on: {
                    change: function ($event) {
                      return _vm.handleChange(index, $event)
                    },
                  },
                },
                "custom-data-field",
                Object.assign({}, field, {
                  customFieldDefinition: _vm.getCustomFieldDefinition(field.id),
                  name: _vm.getFieldName(field),
                }),
                false
              )
            ),
          ],
          2
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }